module.exports = __webpack_public_path__ + "static/pghero-index-8c434cf735620af579a5ae7caf0fc201.png";